import Promise from 'promise-polyfill';
import {} from '../polyfills/Object.assign';
import filtercomponents from '../../_utilities/filtercomponents';
import recursiveLanguageResolve from '../../_utilities/recursive-language-resolve';
import processsearchresultsItem from '../../_utilities/processsearchresults-item';

const prefetchCache = {};

const fetch = (url, language, referrer) => new Promise((resolve, reject) => {
  if (prefetchCache.url === url) {
    resolve(prefetchCache.data);
    return;
  }

  const xhr = new XMLHttpRequest();

  xhr.open('GET', url);
  xhr.setRequestHeader('Accept-Language', language);
  // cors
  const withCredentials = self.origin
    && self.origin.indexOf('localhost') === -1
    && self.origin.indexOf(':3000') === -1
    && self.origin.indexOf('https://templates') === -1;

  xhr.withCredentials = withCredentials;

  if (withCredentials && typeof referrer !== 'undefined') {
    xhr.setRequestHeader('X-Referer', referrer);
  }

  xhr.onload = () => {
    resolve(JSON.parse(xhr.responseText));
  };
  xhr.onerror = reject;
  xhr.ontimeout = reject;

  xhr.send();
});

const prefetch = (url, language, referrer) => {
  fetch(url, language, referrer)
    .then((data) => {
      prefetchCache.url = url;
      prefetchCache.data = data;
    })
    .catch(console.info);
};

const filter = (params) => {
  const {
    url,
    language,
    search,
    source,
    referrer,
    hardwiredFilters,
    itemsPerPage,
    pageNumber = 1,
    config,
  } = params;

  self.swinger = {
    config,
  };

  if (!url) {
    return;
  }

  const hardwiredFiltersSearchSuffix = hardwiredFilters && typeof hardwiredFilters === 'object'
    ? Object.keys(hardwiredFilters).reduce((acc, name) => {
      switch (name) {
        default:
          return `${acc}&filter[${name}][]=${hardwiredFilters[name]}`;

        case 'streaming_type':
        case 'director':
        case 'series':
          return `${acc}&filter[${name}]=${hardwiredFilters[name]}`;
      }
    }, '') : '';

  const fetchUrl = `${url}?${search.replace(/\[object%20Object]/g, '').replace(/\[object Object]/g, '')}${hardwiredFiltersSearchSuffix}&itemsPerPage=${itemsPerPage}&page=${pageNumber}&source=${source}`;

  fetch(fetchUrl, language, referrer)
    .then((data) => {
      const itemsKey = Object.keys(data).filter((key) => ['filters', 'order', 'pagination'].indexOf(key) === -1)[0];
      const promoResult = data[itemsKey].filter((item) => item.isPromo);
      const result = data[itemsKey].filter((item) => !item.isPromo).map((item) => recursiveLanguageResolve(processsearchresultsItem(item), language));
      const filters = recursiveLanguageResolve(filtercomponents(data.filters, hardwiredFilters), language);
      const { totalItemCount } = data.pagination;
      const existsNextPage = !!data.pagination.nextPageHref;

      self.postMessage({
        action: 'result',
        type: itemsKey,
        search,
        result,
        filters,
        order: data.order,
        totalItemCount: totalItemCount - promoResult.length,
        pageNumber,
        existsNextPage,
      });

      if (data.pagination.nextPageHref) {
        const prefetchUrl = `${url}?${search.replace(/\[object%20Object]/g, '').replace(/\[object Object]/g, '')}${hardwiredFiltersSearchSuffix}&itemsPerPage=${itemsPerPage}&page=${pageNumber + 1}&source=${source}`;

        prefetch(prefetchUrl, language, referrer);
      }
    })
    .catch((e) => {
      self.console.error(`Error fetching and processing data from URL "${fetchUrl}"`, e);
    });
};

self.addEventListener('message', (e) => {
  switch (e.data.action) {
    default:
      break;

    case 'preconnect': {
      const { url, language, referrer } = e.data;
      prefetch(url, language, referrer);
      break;
    }

    case 'retrieve': {
      filter(e.data);
      break;
    }
  }
});



// WEBPACK FOOTER //
// ./src/js/webworkers/filter-worker.js